import { Button } from "@/Components/Control/Button"
import { WDescription } from "@/Components/Description"
import { FormWrapper } from "@/Components/Form"
import { Msg } from "@/Components/Msg"
import {
  AgreeAgeCheck,
  AgreeRefundCheck,
  AgreeRiskCheck,
  AgreeTermCheck,
} from "@/Pages/Auth/Register/Checkboxes"
import { useExchangeStep3 } from "@usher/pe-client-front-end-lib"
import { useHistory } from "react-router-dom"
import { ExchangeDocumentUpload } from "../components/ExchangeDocumentUpload"
import { SkipModal } from "./SkipModal"
import "./style.sass"

export const DocumentVerification = () => {
  const history = useHistory()
  const {
    formMethods,
    showSkip,
    onSkipConfirm,
    setShowSkip,
    onSubmit,
    passport,
    photo,
    setStep3,
    isDefaultShop,
    isDocsUploaded,
    loading,
  } = useExchangeStep3({ history })

  if (isDefaultShop && isDocsUploaded)
    return (
      <div style={{ marginRight: 30 }}>
        <WDescription>
          <h2>
            <Msg id="success" />
          </h2>
          <br />
          <Msg id="dv16" />
        </WDescription>
      </div>
    )
  return (
    <FormWrapper methods={formMethods} onSubmit={onSubmit}>
      <div className="document_verification">
        <h4 className="transaction__title">
          <Msg id="dv1" />
        </h4>
        <ExchangeDocumentUpload
          file={passport}
          type="passport"
          marginBottom={35}
          tooltip={
            <>
              <p style={{ marginBottom: 20 }}>
                <Msg id="det1" />
              </p>
              <ul style={{ listStyleType: "disc" }}>
                <Msg id="det2" tag="li" />
                <Msg id="det3" tag="li" />
                <Msg id="det4" tag="li" />
                <Msg id="det5" tag="li" />
                <Msg id="lname" tag="li" />
                <Msg id="name" tag="li" />
                <Msg id="det8" tag="li" />
                <Msg id="det9" tag="li" />
                <Msg id="det10" tag="li" />
              </ul>
            </>
          }
          setFile={(file) => setStep3({ passport: file })}
        />
        <ExchangeDocumentUpload
          file={photo}
          type="photo"
          marginBottom={35}
          tooltip={
            <p style={{ marginBottom: 20 }}>
              <Msg id="det11" />
            </p>
          }
          setFile={(file) => setStep3({ photo: file })}
        />
        <div className="verification-example">
          <ul className="verification-example__list">
            <li className="verification-example__item">
              <span>1</span>
              <Msg id="dv3" />
            </li>
            <li className="verification-example__item">
              <span>3</span>
              <Msg id="dv4" />
            </li>
            <li className="verification-example__item">
              <span>2</span>
              <Msg id="dv5" />
            </li>
            <li className="verification-example__item">
              <span>4</span>
              <Msg id="dv6" />
            </li>
          </ul>
        </div>

        {!isDefaultShop && (
          <SkipModal isShow={showSkip} onConfirm={onSkipConfirm} setShowSkip={setShowSkip} />
        )}
        <div className="policy">
          <AgreeTermCheck />
          <AgreeRiskCheck />
          <AgreeRefundCheck />
          <AgreeAgeCheck />
        </div>
        <div className="exchange__actions">
          <Button loading={loading} type="submit" variant="primary">
            <Msg id="exchange" />
          </Button>
          <Button variant="outlined" onClick={() => history.push("/")}>
            <Msg id="cancel" />
          </Button>
        </div>
      </div>
    </FormWrapper>
  )
}
